import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";

export default function DataTable_Component({
  columns,
  fetchData,
  paginationData,
  totalPayout,
  totalTrips,
  totalFixedTrips,
  totalPpTrips,
}) {
  const [tableData, setTableData] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [search, setSearch] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const pageSize = paginationData.limit || 10;

  /* ✅ INITIAL LOAD */
  useEffect(() => {
    fetchData(1);
    // eslint-disable-next-line
  }, []);

  /* 🔹 UPDATE TABLE */
  useEffect(() => {
    setTableData(paginationData.data || []);
  }, [paginationData.data]);

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchData(
        1,
        month || undefined,
        year || undefined,
        search,
        pageSize,
        fromDate || undefined,
        toDate || undefined,
      );
    }, 500);

    return () => clearTimeout(delay);
  }, [search]);

  /* 🔹 APPLY FILTERS */
  const applyFilters = () => {
    setShowFilterModal(false);
    fetchData(
      1,
      month || undefined,
      year || undefined,
      search,
      pageSize,
      fromDate || undefined,
      toDate || undefined,
    );
  };

  /* 🔹 REMOVE FILTERS */
  const removeFilters = () => {
    setMonth("");
    setYear("");
    setSearch("");
    setFromDate("");
    setToDate("");
    setShowFilterModal(false);
    fetchData(1, undefined, undefined, "", pageSize, undefined, undefined);
  };

  /* 🔹 PAGE CHANGE */
  const handlePageChange = (page) => {
    fetchData(
      page,
      month || undefined,
      year || undefined,
      search,
      pageSize,
      fromDate || undefined,
      toDate || undefined,
    );
  };

  /* 🔹 PAGE SIZE CHANGE */
  const handleRowsPerPageChange = (newLimit) => {
    fetchData(
      1,
      month || undefined,
      year || undefined,
      search,
      newLimit,
      fromDate || undefined,
      toDate || undefined,
    );
  };

  return (
    <div className="table-responsive">
      {/* 🔍 SEARCH + FILTER */}
      <div className="row justify-content-between mb-2">
        <div className="col-md-3 mb-2">
          <input
            type="text"
            className="form-control"
            placeholder="Search by User Name / Phone"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="col-md-9 mb-2">
          <button
            className="btn btn-primary me-2"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>

          <button className="btn btn-success me-2">
            Revenue : ₹{totalPayout.toLocaleString()}
          </button>

          <button className="btn btn-success me-2">
            Trips : {totalTrips.toLocaleString()}
          </button>

          <button className="btn btn-success me-2">
            Fixed Trips : {totalFixedTrips.toLocaleString()}
          </button>

          <button className="btn btn-success me-2">
            PP Trips : {totalPpTrips.toLocaleString()}
          </button>
        </div>
      </div>

      {/* 📊 TABLE */}
      <DataTable
        columns={columns}
        data={tableData}
        pagination
        paginationServer
        paginationPerPage={pageSize}
        paginationRowsPerPageOptions={[5, 10, 15, 20]}
        paginationTotalRows={paginationData.totalUsers || 0}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handleRowsPerPageChange}
        fixedHeader
        highlightOnHover
        responsive
      />

      {/* 🔘 FILTER MODAL */}
      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        applyFilters={applyFilters}
        removeFilters={removeFilters}
        month={month}
        setMonth={setMonth}
        year={year}
        setYear={setYear}
        fromDate={fromDate}
        setFromDate={setFromDate}
        toDate={toDate}
        setToDate={setToDate}
      />
    </div>
  );
}
